import * as f from '../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
} from  '../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


const unitQuery = `
    glAccount(id: $id) {
        name
        type
        id
        isActive
        manager {
            id
            enterpriseId
        }
        parent {
            id
            displayName
        }
    }
`

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allGlAccounts'), unitQuery}

class GlAccountMinimalTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "GlAccountMinimalTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.setAdditionalFilters(this.filters)
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'name',
                new DataMapper("name"),
                new f.FilterDescription(new f.TextFilter("name")),
                {label: 'Name'}
            ),
            new TableFieldDescription(
                'type',
                new DataMapper("type"),
                new f.FilterDescription(new f.TextFilter("type")),
                {label: 'Type'}
            ),
            new TableFieldDescription(
                'parent',
                new DataMapper("parent.displayName"),
                new f.FilterDescription(new f.TextFilter("parent")),
                {label: 'Parent'}
            ),
            new TableFieldDescription(
                'manager',
                new DataMapper("manager.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("manager")),
                {label: 'Manager'}
            )
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(GlAccountMinimalTableCreator)

export default GlAccountMinimalTableCreator;
